'use client';

import { useRouter } from 'next/navigation';

import { ROUTES } from '@/constants';
import { useAuthStore } from '@/stores/AuthStore';

import { MarketButton } from './MarketButton';

interface InviteReceiverButtonProps {
  className?: string;
  inviterCode: string;
}

export const InviteReceiverButton = ({
  className,
  inviterCode,
}: InviteReceiverButtonProps) => {
  const router = useRouter();
  const isLogin = useAuthStore((state) => state.isLogin);

  const handleClick = () => {
    if (!isLogin) {
      router.push(
        ROUTES.LOGIN.withSearchParams({
          searchParams: {
            memberCode: inviterCode,
            redirect: location.href,
          },
        }),
      );

      return;
    }

    // 이미 로그인된 경우 기부 페이지로 이동
    const giftSection = document.getElementById('today-gift-section');
    if (giftSection) {
      giftSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <MarketButton className={className} onClick={handleClick}>
      {isLogin ? '100% 당첨 웰포인트 받기' : '지금 회원가입하고 혜택 받기'}
    </MarketButton>
  );
};
